// extracted by mini-css-extract-plugin
var _1 = "FormCreateCustomerTransferModal-module__available-balance";
var _2 = "FormCreateCustomerTransferModal-module__button-container";
var _3 = "FormCreateCustomerTransferModal-module__button-disabled";
var _4 = "FormCreateCustomerTransferModal-module__button-subcontainer";
var _5 = "FormCreateCustomerTransferModal-module__close-button";
var _6 = "FormCreateCustomerTransferModal-module__close-button-container";
var _7 = "FormCreateCustomerTransferModal-module__container";
var _8 = "FormCreateCustomerTransferModal-module__container-justify-end";
var _9 = "FormCreateCustomerTransferModal-module__disabledButton";
var _a = "FormCreateCustomerTransferModal-module__error-text";
var _b = "FormCreateCustomerTransferModal-module__filter-container";
var _c = "FormCreateCustomerTransferModal-module__form-container";
var _d = "FormCreateCustomerTransferModal-module__full-width";
var _e = "FormCreateCustomerTransferModal-module__joint-account-details-container";
var _f = "FormCreateCustomerTransferModal-module__products-container";
var _10 = "FormCreateCustomerTransferModal-module__remarks-text";
var _11 = "FormCreateCustomerTransferModal-module__span-2";
var _12 = "FormCreateCustomerTransferModal-module__test-button";
export { _1 as "available-balance", _2 as "button-container", _3 as "button-disabled", _4 as "button-subcontainer", _5 as "close-button", _6 as "close-button-container", _7 as "container", _8 as "container-justify-end", _9 as "disabledButton", _a as "error-text", _b as "filter-container", _c as "form-container", _d as "full-width", _e as "joint-account-details-container", _f as "products-container", _10 as "remarks-text", _11 as "span-2", _12 as "test-button" }
